(function ($) {
	// On Dom Ready
	$(function () {
		alignSliderButtons();
	});

	// on window resize
	$(window).on('resize', function () {
		alignSliderButtons();
	});

	// position the play/pause button on every hero slider
	function alignSliderButtons(){
		$('.global-hero .swiper, .block-photoslider .swiper, .project-hero .swiper').each(function() {
			const playPauseButton = $(this).find('.btn-play-pause');
			if(playPauseButton){
				const playPauseButtonHeight = playPauseButton.height();
				const slideImageHeight = $(this).find('.swiper-slide img').height();
				playPauseButton.css('top', (slideImageHeight - playPauseButtonHeight) + 'px');
			}

			const navButton = $(this).find('.swiper-navigation-wrapper');
			if(navButton){
				const screenWidth = $(window).width();
				const navButtonHeight = navButton.height();
				const slideImageHeight = $(this).find('.swiper-slide img').height();

				if(screenWidth > 1200){
					navButton.css('top', (slideImageHeight - navButtonHeight) + 'px');
				}
				else{
					navButton.css('top', slideImageHeight + 'px');
				}
			}
		})
	}
})(jQuery);

